module.exports = __webpack_public_path__ + "static/media/30OIOS8.12797e4e.jpg";